// Shared Turnstile loader — same widget/site key CoverEditorDemo.jsx uses (site key is public
// by design; the SECRET is what's confidential, verified server-side only).
export const TURNSTILE_SITE_KEY = '0x4AAAAAAEXIYMOblg9Iku8_';

let turnstileScriptPromise = null;
export function loadTurnstileScript() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.turnstile) return Promise.resolve();
  if (turnstileScriptPromise) return turnstileScriptPromise;
  turnstileScriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Turnstile script failed to load'));
    document.head.appendChild(s);
  });
  return turnstileScriptPromise;
}
